module.exports = __webpack_public_path__ + "img/文创部.ca8736ff.jpg";